import { FormattedMessage } from 'react-intl';

const InvalidPhoneNumber = (): JSX.Element => {
  return (
    <FormattedMessage
      id="account_v2.components.form_errors.invalid_phone_number"
      defaultMessage="Please use between 0 and 14 numbers."
      description="AL-1028; Screenshot: components.form_errors.invalid_phone_number.jpg"
    />
  );
};

export default InvalidPhoneNumber;
